import React from 'react';

const AnalyticsTooltip = ({ content, children, name, role, email, style }) => (
  <div className={ style }>
    { children }
    <div className="tooltip">
      <div className="tooltip-inner">
        <div className="arrow-outer" />
        <div className="arrow-inner" />
        <div className="tooltip-content">
          <p className="small">{ content }</p>
        </div>
      </div>
    </div>
  </div>
);

export default AnalyticsTooltip;



/** WEBPACK FOOTER **
 ** ./src/components/analytics-tooltip/index.js
 **/